import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import {
  BackendLog,
  BackendLogDetail,
  BackendLogFilter,
  BackendLogListResponse,
  BackendLogStats,
} from '../interfaces/backend-log.interface';

/**
 * Backend log megjelenítés service - admin Rendszer tab használja.
 * Csak admin role férhet hozzá a backend oldalon is.
 */
@Injectable({
  providedIn: 'root',
})
export class BackendLogsService extends BaseHttpService {
  /**
   * Paginált, szűrt log lista lekérdezése.
   */
  getLogs(filter: BackendLogFilter = {}): Observable<BackendLogListResponse> {
    let params = new HttpParams();

    if (filter.level && filter.level.length > 0) {
      filter.level.forEach((lv) => {
        params = params.append('level', lv);
      });
    }
    if (filter.search) {
      params = params.set('search', filter.search);
    }
    if (filter.date_from) {
      params = params.set('date_from', filter.date_from);
    }
    if (filter.date_to) {
      params = params.set('date_to', filter.date_to);
    }
    if (filter.user_id && filter.user_id.length > 0) {
      filter.user_id.forEach((id) => {
        params = params.append('user_id', String(id));
      });
    }
    if (filter.logger_name) {
      params = params.set('logger_name', filter.logger_name);
    }
    if (filter.request_path) {
      params = params.set('request_path', filter.request_path);
    }
    params = params.set('page', String(filter.page ?? 1));
    params = params.set('page_size', String(filter.page_size ?? 50));

    return this.get<BackendLogListResponse>('/api/system/logs', params);
  }

  /**
   * Egy log bejegyzés teljes részletei (traceback + body).
   */
  getLogDetail(id: number): Observable<BackendLogDetail> {
    return this.get<BackendLogDetail>(`/api/system/logs/${id}`);
  }

  /**
   * Utolsó 24h darabszám szintenként (badge-hez).
   */
  getStats(): Observable<BackendLogStats> {
    return this.get<BackendLogStats>('/api/system/logs/stats');
  }

  /**
   * Egyedi log bejegyzés törlése azonosító alapján.
   */
  deleteLog(id: number): Observable<void> {
    return this.delete<void>(`/api/system/logs/${id}`);
  }

  /**
   * Az összes log bejegyzés törlése.
   */
  deleteAllLogs(): Observable<{ deleted_count: number }> {
    return this.delete<{ deleted_count: number }>('/api/system/logs/all');
  }
}
